// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
const globalPageContext = require('client/lib/business-events/page-context')
// Client V2 common imports
const { render } = require('client-v2/common/client')
const newUserTooltipActions = require('client-v2/common/containers/tooltips/actions/new-user')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const { showArticleProfileModal } = require('./containers/feed/actions')

const { store } = render(configureStore, rootFactory)

store.dispatch(newUserTooltipActions.showUserProfileFollowTooltip())

const initialState = store.getState()

const businessEventsPageActions = {
  'user-profile.showCollectionsCreated': 'mixes',
  'user-profile.showCollectionsSubscribed': 'followingMixes',
  'user-profile.showFollowers': 'followers',
  'user-profile.showFriends': 'friends',
  'user-profile.showPosts': 'posts'
}
const pageAction = businessEventsPageActions[initialState.router.action]

globalPageContext.setPageContext({
  pageName: `user.${pageAction}`,
  streamId: initialState.profileUser.id,
  streamType: 'user'
})

businessEvents.trackInternal('pageview')
businessEvents.trackSegment('pageview')

const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
if (pageAction === 'posts' && queryParams.modal) {
  store.dispatch(showArticleProfileModal())
}
